import React from 'react';
import Icon from '../../../components/AppIcon';

const ProsAndCons = ({ pros, cons }) => {
  return (
    <div className="bg-white rounded-xl shadow-subtle border border-border p-6 mb-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="flex items-center justify-center w-10 h-10 bg-accent/10 rounded-lg">
          <Icon name="Scale" size={20} className="text-accent" />
        </div>
        <div>
          <h2 className="text-xl font-bold text-text-primary">Pros & Cons</h2>
          <p className="text-sm text-muted-foreground">Honest assessment after 6 months of testing</p>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Pros */}
        <div className="space-y-4">
          <div className="flex items-center gap-2 mb-4">
            <div className="flex items-center justify-center w-6 h-6 bg-success/10 rounded-full">
              <Icon name="Plus" size={14} className="text-success" />
            </div>
            <h3 className="font-semibold text-success">What We Love</h3>
          </div>
          
          <div className="space-y-3">
            {pros?.map((pro, index) => (
              <div key={index} className="flex items-start gap-3 p-3 bg-success/5 rounded-lg border-l-4 border-success">
                <Icon name="Check" size={16} className="text-success mt-0.5 flex-shrink-0" />
                <div>
                  <h4 className="font-medium text-text-primary mb-1">{pro?.title}</h4>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {pro?.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Cons */}
        <div className="space-y-4">
          <div className="flex items-center gap-2 mb-4">
            <div className="flex items-center justify-center w-6 h-6 bg-destructive/10 rounded-full">
              <Icon name="Minus" size={14} className="text-destructive" />
            </div>
            <h3 className="font-semibold text-destructive">Areas for Improvement</h3>
          </div>
          
          <div className="space-y-3">
            {cons?.map((con, index) => (
              <div key={index} className="flex items-start gap-3 p-3 bg-destructive/5 rounded-lg border-l-4 border-destructive">
                <Icon name="X" size={16} className="text-destructive mt-0.5 flex-shrink-0" />
                <div>
                  <h4 className="font-medium text-text-primary mb-1">{con?.title}</h4>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {con?.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="mt-6 pt-6 border-t border-border">
        <div className="bg-muted/30 rounded-lg p-4">
          <div className="flex items-start gap-3">
            <Icon name="Info" size={20} className="text-primary mt-0.5" />
            <div>
              <h4 className="font-semibold text-text-primary mb-2">Our Honest Take</h4>
              <p className="text-sm text-muted-foreground leading-relaxed">
                After extensive testing, this vacuum excels in specific areas but has limitations. 
                We believe in transparent reviews that help you make informed decisions based on 
                your specific cleaning needs and home environment.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProsAndCons;